export const getCardsInRowAmount = (total, showTitleAsCard) => {
  const numberOfCards = total + (showTitleAsCard ? 1 : 0)
  return (numberOfCards % 3 === 0 && numberOfCards <= 9) || ((numberOfCards + 1) % 3 === 0 && numberOfCards <= 6)
    ? 3
    : 4
}
